import React, { useContext, useRef } from "react"
import fbIcon from "../../assets/icons/fb.svg"
import twitterIcon from "../../assets/icons/twitter.svg"
import "./Share.scss"
import ReactShareSocial from "react-share-social"
import { LanguageContext } from "../../contexts/languageContext"
import { translateText } from "../../utils/translateText"

const Share = ({ data }) => {
  const { facebook: facebookUrl, twitter: twitterUrl } = data

  const languageContext = useContext(LanguageContext)
  const currentLanguage = languageContext[0]
  const googleSheetData = languageContext[2]

  const SOCIAL_MEDIA_ICONS = {
    facebook: { logoSrc: fbIcon, logoAlt: "fb", url: facebookUrl },
    twitter: { logoSrc: twitterIcon, logoAlt: "twitter", url: twitterUrl },
  }

  const shareSocialRef = useRef()

  const handleOnSocialMediaButtonClick = socialMediaName => {
    if (shareSocialRef?.current) {
      const ref = shareSocialRef.current
      const socialMediaButtons = ref.children[0].children[0].children

      for (let button of socialMediaButtons) {
        if (button.ariaLabel === socialMediaName) {
          button.click()
          break
        }
      }
    }
  }

  const socialMediaNames = Object.keys(SOCIAL_MEDIA_ICONS)
  return (
    <>
      <div className="share-container">
        {socialMediaNames.map(key => {
          const currentSocialMedia = SOCIAL_MEDIA_ICONS[key]
          return (
            <div
              key={key}
              className="share-button"
              onClick={() => handleOnSocialMediaButtonClick(key)}
              onKeyDown={e =>
                e.key === "Enter" && handleOnSocialMediaButtonClick(key)
              }
              role="button"
              tabIndex={0}
            >
              <img
                src={currentSocialMedia.logoSrc}
                alt={currentSocialMedia.logoAlt}
                width="20"
                height="20"
                className="social-icon"
              />
              <span className="text">
                {`${translateText(
                  "Share on",
                  currentLanguage.fullTitle,
                  googleSheetData
                )}`}
                {currentSocialMedia.name}
              </span>
            </div>
          )
        })}
      </div>
      <div ref={shareSocialRef}>
        <ReactShareSocial
          url={typeof window !== "undefined" ? window.location.hostname : ""}
          socialTypes={socialMediaNames}
          onSocialButtonClicked={() => {}}
        />
      </div>
    </>
  )
}

export default Share
